import pipeline from '@/pipeline';
import { RouterParams } from './interfaces/IRouter';

const hasCityInStoreMiddleware = ({ next, router }: RouterParams) => {
  // Load duro em /selecao-de-polo: o interpreter ainda não iniciou, então `prev()` não
  // transiciona (o XState 4 só avisa no console) e o `next(false)` deixaria o app parado
  // numa navegação abortada, sem ninguém para navegar. Segue a cadeia e deixa o
  // terminador do guard tratar o caso.
  if (!pipeline.initialized) return next();

  const selectedCity = router?.app?.$store?.getters?.selectedCity;

  if (!selectedCity?.city || !selectedCity?.state) {
    // Veto: aborta esta navegação e deixa o `onTransition` → `navigateToStep` fazer a
    // única navegação. Antes fazia `prev()` E `next()`, produzindo duas navegações
    // concorrentes.
    //
    // ATENÇÃO: isso depende de o `prev()` levar a OUTRA rota. Hoje vale
    // (`campusSelection.PREV → citySelection`, rotas distintas), mas um passo novo cujo
    // PREV caia na mesma rota não dispara navegação nenhuma e deixa a tela travada.
    next(false);
    return pipeline.prev();
  }

  return next();
};

export { hasCityInStoreMiddleware };
